'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  /*换肤*/
  skin: {},
  /*POST请求携带token*/
  token: false,
  datumValue: 4,
  datumObj: 2,
  /*菜单选中key*/
  menuActiveName: '',
  /*菜单自动展开key*/
  menuOpenName: [],
  /*页码数*/
  pageSize: 10,
  /*大模态框状态（已废弃）*/
  modelDisabled: true,
  /*面包屑*/
  crumbsList: [],
  /*菜单列表*/
  menuList: [],
  // 国际化语言列表
  langList: [],
  /*不显示头routername */
  hideRouterName: ['play', 'login', 'assessmentResultSuccess', 'speedTest', 'websitedownload', 'appDownload', 'appPolymer', 'questionnairepaper', 'applicationSecret', 'techAuth', 'paper', 'paperresult', 'exampractice', 'classAssessment', 'retrieve', 'resetPasswords', 'resetEmail', 'resetPhone', 'bindPhone', 'exercise', 'qusetionnaireresult', 'certificate-detail', 'examcertificateDetail', 'livePlay', 'validPhone', 'index', 'emailReset'],
  /*设置特定router背景颜色 */
  bgRouter: {
    '#eee': ['paper', 'paperresult', 'qusetionnaireresult', 'assessmentResultSuccess'],
    '#2d2d2e': ['play'],
    '#F7F8FA': ['appDownload']
  },
  /* 资源列表-帮助手册选中状态 */
  helpSelected: false,
  /*将免过滤请求设置黑名单，防止token异常*/
  filterFreeRequests: ['user/validateCaptcha', 'user/event/visit', 'api-message/portal/sms/open/generatePhoneCode', 'api-ouser/portal/user/open/account/resetPasswd', 'api-message/portal/sms/open/validPhoneCode', 'api-ouser/portal/user/open/getBindAccount', 'api-ouser/portal/user/open/getLoginUser']
};
exports.default = state;